module.exports = "/packs/015-3f2f70829088c12b82feb8c0e171a4bf.jpg";